<template>
  <div v-if="name !== 'Overflow'">
    <div v-if="options" class="dropdown">
      <!-- Dropdown Input -->
      <input
        v-model="searchFilter"
        class="dropdown-input"
        :name="name"
        :disabled="disabled"
        :placeholder="placeholder"
        @focus="showOptions()"
        @blur="exit()"
        @keyup="keyMonitor"
      />

      <!-- Dropdown Menu -->
      <div class="dropdown-content" v-show="optionsShown">
        <div
          v-for="(option, index) in filteredOptions"
          :key="index"
          class="dropdown-item"
          @mousedown="selectOption(option)"
        >
          {{ option.name || option.id || "-" }}
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div id="overFlowBox">Overflow</div>
  </div>
</template>

<script>
import { useAppointmentStore } from "./../../stores/appointmentsStore";
import { useDateStore } from "./../../stores/datestore";
import { inject, toRaw, unref } from "vue";

export default {
  name: "ResourceLabel",
  props: {
    name: {
      type: String,
      required: false,
      default: "dropdown",
      note: "Input name",
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
      note: "Options of dropdown. An array of options with id and name",
    },
    placeholder: {
      type: String,
      required: false,
      default: "Select a Stylist",
      note: "Placeholder of dropdown",
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: "Disable the dropdown",
    },
    maxItem: {
      type: Number,
      required: false,
      default: 6,
      note: "Max items showing",
    },
    selectedResource: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  setup() {
    const apptStore = useAppointmentStore();
    const { selectedDate } = useDateStore();
    const resourceList = inject("resourceList");
    return { apptStore, selectedDate, resourceList };
  },
  data() {
    return {
      selected: {},
      optionsShown: false,
      searchFilter: this.selectedResource ? this.selectedResource.name : "",
    };
  },
  computed: {
    filteredOptions() {
      const filtered = [];
      const regOption = new RegExp(this.searchFilter, "ig");
      /* filtering process - added later */
      let filteredList = [];
      for (let entry in this.resourceList) {
        if (this.resourceList[entry] !== null) {
          let availableValue = toRaw(this.resourceList[entry]);
          filteredList.push(availableValue);
        }
      }
      let filteredOptions = this.options.filter((option) => {
        let result = filteredList.find(
          (listItem) => listItem.name === option.name
        );
        //console.log(result);
        return typeof result !== "object" ? true : false;
      });
      /* ending own code */
      for (const option of filteredOptions) {
        if (this.searchFilter.length < 1 || option.name.match(regOption)) {
          if (filtered.length < this.maxItem) filtered.push(option);
        }
      }
      return filtered;
    },
  },
  watch: {
    searchFilter() {
      if (!this.selected) {
        if (this.filteredOptions.length === 0) {
          this.selected = {};
        } else if (this.selectedResource !== undefined) {
          this.selected = this.selectedResource;
        } else {
          this.selected = this.filteredOptions[0];
        }
      }
      this.$emit("filter", this.searchFilter);
    },
    selectedResource(value) {
      this.selected = value;
      this.searchFilter = this.selected.name;
    },
  },
  created() {
    this.$emit("selected", this.selected);
  },
  methods: {
    selectOption(option) {
      this.selected = option;
      this.optionsShown = false;
      this.searchFilter = this.selected.name;
      this.$emit("selected-resource", this.selected);
      this.apptStore.addMarkedStylists({
        resource: this.name,
        selected: this.selected,
      });
    },
    showOptions() {
      if (!this.disabled) {
        this.searchFilter = "";
        this.optionsShown = true;
      }
    },
    exit() {
      if (!this.selected.id) {
        this.selected = {};
        this.searchFilter = "";
      } else {
        this.searchFilter = this.selected.name;
      }
      this.$emit("selected", this.selected);
      this.optionsShown = false;
    },
    // Selecting when pressing Enter
    keyMonitor: function (event) {
      if (event.key === "Enter" && this.filteredOptions[0])
        this.selectOption(this.filteredOptions[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  display: block;
  //margin: auto;
  //flex: 1 1 0px;
  margin-bottom: 18px;
  .dropdown-input {
    background: #fff;
    cursor: pointer;
    border: 1px solid #e7ecf5;
    border-radius: 3px;
    color: #333;
    display: block;
    font-size: 0.8em;
    padding: 6px;
    width: 100%;
    &:hover {
      background: #f8f8fa;
    }
  }
  .dropdown-content {
    position: absolute;
    background-color: #fff;
    min-width: 248px;
    max-width: 248px;
    max-height: 248px;
    border: 1px solid #e7ecf5;
    box-shadow: 0px -8px 34px 0px rgba(0, 0, 0, 0.05);
    overflow: auto;
    z-index: 1;
    .dropdown-item {
      color: black;
      font-size: 0.7em;
      line-height: 1em;
      padding: 8px;
      text-decoration: none;
      display: block;
      cursor: pointer;
      &:hover {
        background-color: #e7ecf5;
      }
    }
  }
  .dropdown:hover .dropdowncontent {
    display: block;
  }
}
</style>
